import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-multiple-plan',
  templateUrl: './multiple-plan.component.html',
  styleUrls: ['./multiple-plan.component.css']
})
export class MultiplePlanComponent implements OnInit {

  constructor(private route: Router) {
    this.route.events.subscribe((e) => {
      
    });
  }

  ngOnInit(): void {
    this.route.navigate(['/flex-plan-multiple']);
  }

}
